import { FormattedMessage } from 'react-intl';
import { NavItemType } from 'types/menu';
import {
    mgmtLocationsPath,
    mgmtKillSwitchPath,
    mgmtProjectRequestsPath,
    mgmtProvidersPath,
    mgmtResourcesPath,
    mgmtResourceRequestsPath,
    mgmtUsersPath,
    mgmtCommandTemplatesPath,
} from 'routes/paths';
import { platformAdminRoleName, providerAdminRoleName } from 'constants/permissions';
import { GrUserSettings, GrResources, GrServerCluster, GrCloudComputer } from 'react-icons/gr';
import { LuFileKey, LuBookKey, LuLayoutTemplate } from 'react-icons/lu';
import { FaUnlockKeyhole } from 'react-icons/fa6';
import { TbSnowflake } from 'react-icons/tb';

const icons = {
    LuFileKey,
    FaUnlockKeyhole,
    LuBookKey,
    LuLayoutTemplate,
    GrResources,
    GrUserSettings,
    GrServerCluster,
    GrCloudComputer,
    TbSnowflake,
};

const administrationManagement: NavItemType = {
    id: 'management',
    title: <FormattedMessage id='management' />,
    type: 'group',
    permissions: [platformAdminRoleName, providerAdminRoleName],
    children: [
        {
            id: 'users',
            title: <FormattedMessage id='users' />,
            type: 'item',
            url: mgmtUsersPath(),
            icon: icons.GrUserSettings,
            permissions: [platformAdminRoleName],
        },
        {
            id: 'management-providers',
            title: <FormattedMessage id='management-providers' />,
            type: 'item',
            url: mgmtProvidersPath(),
            icon: icons.GrCloudComputer,
            permissions: [platformAdminRoleName],
        },
        {
            id: 'management-locations',
            title: <FormattedMessage id='management-locations' />,
            type: 'item',
            url: mgmtLocationsPath(),
            icon: icons.GrServerCluster,
            permissions: [platformAdminRoleName, providerAdminRoleName],
        },
        {
            id: 'management-kill-switch',
            title: <FormattedMessage id='management-kill-switch' />,
            type: 'item',
            url: mgmtKillSwitchPath(),
            icon: icons.TbSnowflake,
            permissions: [platformAdminRoleName, providerAdminRoleName],
        },
        {
            id: 'management-command-templates',
            title: <FormattedMessage id='management-command-templates' />,
            type: 'item',
            url: mgmtCommandTemplatesPath(),
            icon: icons.LuLayoutTemplate,
            permissions: [platformAdminRoleName, providerAdminRoleName],
        },
        {
            id: 'resources',
            title: <FormattedMessage id='resources' />,
            type: 'item',
            url: mgmtResourcesPath(),
            icon: icons.GrResources,
            permissions: [platformAdminRoleName, providerAdminRoleName],
        },
        {
            id: 'management-requests',
            title: <FormattedMessage id='management-requests' />,
            type: 'collapse',
            icon: icons.FaUnlockKeyhole,
            permissions: [platformAdminRoleName],
            children: [
                {
                    id: 'resource-requests',
                    title: <FormattedMessage id='resource-requests' />,
                    type: 'item',
                    url: mgmtResourceRequestsPath(),
                    icon: icons.LuBookKey,
                    permissions: [platformAdminRoleName],
                },
                {
                    id: 'project-requests',
                    title: <FormattedMessage id='project-requests' />,
                    type: 'item',
                    url: mgmtProjectRequestsPath(),
                    icon: icons.LuFileKey,
                    permissions: [platformAdminRoleName],
                },
            ],
        },
    ],
};

export default administrationManagement;
